export const SubcontractSettlementRouting = [
  {
    path: "/subcontractManagement/settlement/list",
    name: "subcontract-management-subcontract-settlement-list",
    meta: { title: "分包结算" },
    component: () => import("@/views/subcontract-management/subcontract-settlement/list/index.vue"),
  },
  {
    hidden: true,
    path: "/subcontractManagement/settlement/create",
    name: "add-subcontract-management-subcontract-settlement-list",
    meta: { title: "新增分包结算",comName:"subcontractManagementSettlementFormCreate" },
    component: () => import("@/views/subcontract-management/subcontract-settlement/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/subcontractManagement/settlement/edit/:id",
    name: "edit-subcontract-management-subcontract-settlement-list",
    meta: { title: "编辑分包结算",comName:"subcontractManagementSettlementFormCreate" },
    component: () => import("@/views/subcontract-management/subcontract-settlement/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/subcontractManagement/settlement/detail/:id",
    name: "add-subcontract-management-subcontract-settlement-detail",
    meta: { title: "分包结算详情" },
    component: () =>
      import("@/views/subcontract-management/subcontract-settlement/form-detail/index.vue"),
  },
  {
    hidden: true,
    path: "/subcontractManagement/settlement/flowPrint/:id",
    name: "add-subcontract-management-subcontract-settlement-flowPrint",
    meta: { title: "打印详情" },
    component: () =>
      import("@/views/subcontract-management/subcontract-settlement/flow-print/index.vue"),
  },
];
